/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type AssignExperimentGroupsContainer_user$ref = any;
type LogAccountCreationContainer_user$ref = any;
type LogTabContainer_user$ref = any;
type NewUserTourContainer_user$ref = any;
type UserBackgroundImageContainer_user$ref = any;
type UserMenuContainer_user$ref = any;
type WidgetsContainer_user$ref = any;
export type ExperimentActionReferralNotification = "CLICK" | "DISMISS" | "NONE" | "%future added value";
export type ExperimentActionSearchIntro = "CLICK" | "DISMISS" | "NONE" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type DashboardContainer_user$ref: FragmentReference;
declare export opaque type DashboardContainer_user$fragmentType: DashboardContainer_user$ref;
export type DashboardContainer_user = {|
  +id: string,
  +userId: ?string,
  +experimentActions: ?{|
    +referralNotification: ?ExperimentActionReferralNotification,
    +searchIntro: ?ExperimentActionSearchIntro,
  |},
  +notifications: $ReadOnlyArray<?{|
    +code: ?string,
    +variation: string,
  |}>,
  +joined: ?string,
  +searches: ?number,
  +tabs: ?number,
  +shopSignupTimestamp: ?string,
  +showSfacExtensionPrompt: boolean,
  +$fragmentRefs: WidgetsContainer_user$ref & UserBackgroundImageContainer_user$ref & UserMenuContainer_user$ref & LogTabContainer_user$ref & LogAccountCreationContainer_user$ref & NewUserTourContainer_user$ref & AssignExperimentGroupsContainer_user$ref,
  +$refType: DashboardContainer_user$ref,
|};
export type DashboardContainer_user$data = DashboardContainer_user;
export type DashboardContainer_user$key = {
  +$data?: DashboardContainer_user$data,
  +$fragmentRefs: DashboardContainer_user$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "DashboardContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "userId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "experimentActions",
      "storageKey": null,
      "args": null,
      "concreteType": "ExperimentActionsOutput",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "referralNotification",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "searchIntro",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "notifications",
      "storageKey": null,
      "args": null,
      "concreteType": "notifications",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "code",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "variation",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "joined",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "searches",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "tabs",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "shopSignupTimestamp",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "showSfacExtensionPrompt",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "WidgetsContainer_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "UserBackgroundImageContainer_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "UserMenuContainer_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "LogTabContainer_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "LogAccountCreationContainer_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "NewUserTourContainer_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "AssignExperimentGroupsContainer_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'fc702ee29f752b38bfafae0db36186b0';
module.exports = node;
